import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-card-replacement",
  "use": "icon-card-replacement-usage",
  "viewBox": "0 0 16.66666603088379 16.66666603088379",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 16.66666603088379 16.66666603088379\" id=\"icon-card-replacement\"><g><path d=\"M8.33333,0C12.9358,0,16.6667,3.73083,16.6667,8.33333C16.6667,12.9358,12.9358,16.6667,8.33333,16.6667C3.73083,16.6667,0,12.9358,0,8.33333C0,3.73083,3.73083,0,8.33333,0ZM8.33333,3.33333C7.8731,3.33333,7.5,3.70643,7.5,4.16667L7.5,8.33333C7.50005,8.55433,7.58788,8.76626,7.74417,8.9225L10.2442,11.4225C10.5711,11.7383,11.0909,11.7338,11.4124,11.4124C11.7338,11.0909,11.7383,10.5711,11.4225,10.2442L9.16667,7.98833L9.16667,4.16667C9.16667,3.70643,8.79357,3.33333,8.33333,3.33333Z\" fill=\"#9E5CF7\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/card-replacement.svg
// module id = XhM0
// module chunks = 119